
function shares(types, pt_img, url){
    if(!pt_img) pt_img='';
    if(url == "" || url == undefined || url == 'undefined'){
        var url = location.href;//window.location.hostname;
    }
    switch(types){
        case "fb":
            window.open('http://www.facebook.com/share.php?u='.concat(encodeURIComponent(url)) );
            break;
        case "tr":
            window.open('https://twitter.com/intent/tweet?original_referer='+encodeURIComponent(url)+'&url='+encodeURIComponent(url));
            // window.open('http://twitter.com/home/?status='.concat(encodeURIComponent(document.title)) .concat('') .concat(encodeURIComponent(url)))
            break;
        case "gp":
            window.open('http://plus.google.com/share?url='.concat(encodeURIComponent(url)) )
            break;
        case "sn":
            window.open('http://v.t.sina.com.cn/share/share.php?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(document.title));
            break;
        case "pt":
            window.open('http://pinterest.com/pin/create/like/?url=' + encodeURIComponent(url) +'&media='+encodeURIComponent(pt_img) + '&description=' + encodeURIComponent(document.title));
            break;
        case "line":
            //http://line.naver.jp/R/msg/text/?{msg}
            //msg = 在LINE裡面顯示的內容
            //僅限行動裝置
            window.open('https://social-plugins.line.me/lineit/share?url='+encodeURIComponent(url));
            break;
    }
    return false;
}

function gotoURL(url,type){
    if(type == "open"){
        window.open(url);
    }else{
        window.location.href=url;
    }
}

// 鎖捲軸
// 例: 如果要鎖 body:
// var body = $('body');
// lockScroll(body);
function lockScroll(target) {
    var scroll_top = $(window).scrollTop();
    var lock_count = $(target).data('lock_count');

    if (typeof lock_count === 'undefined' || lock_count === 0) {
        $(target).data('lock_count', 1);

        target.data('scroll_style', target.attr('style'));
        target.data('scroll_top'  , scroll_top);
        target.css({"overflow":"hidden", "position":"fixed", "top": (scroll_top * -1)+"px"});
    } else {
        $(target).data('lock_count', lock_count + 1);
    } // end of if

} // end of function

// 開捲軸 - 如果鎖了3次, 需要呼叫此　function 3 次後才會解鎖
//
// target　要解開鎖的目標
// unlock_all 強制解鎖, 無視鎖被加了幾次
function unlockScroll(target, unlock_all) {

    var lock_count = $(target).data('lock_count');

    if (typeof lock_count === 'undefined' || lock_count === 0) {
        lock_count = 0;
        $(target).data('lock_count', 0);
    } else {
        lock_count = lock_count - 1;
        $(target).data('lock_count', lock_count);
    } // end of if

    if (lock_count === 0 || (typeof unlock_all !== 'undefined' && unlock_all === true)) {
        var scroll_top   = target.data('scroll_top'  );
        var scroll_style = target.data('scroll_style');

        if (scroll_style) {
            target.attr('style', scroll_style);
        } else {
            target.removeAttr('style');
        }

        $(window).scrollTop(scroll_top);
    } // end of if

} // end of function

var auto_scroll_is_running = 0;
$(function(){
    $('.rd_gotop').on('click',function () {
        if(auto_scroll_is_running === 0) {
            auto_scroll_is_running = 1;
            if ($(".rd_main_content")[0]){
                $('.rd_main_content').animate({
                    opacity: 0,
                }, 1500, null, function () {
                    $('html, body').animate({scrollTop: 0}, 1000);
    
                    $('.rd_main_content').scrollTop(0);
    
                    $('.rd_main_content').animate({
                        opacity: 1,
                    }, 1000,function () {
                        auto_scroll_is_running = 0;
                    });
                });
            }else{
                $('html, body').animate({scrollTop: 0}, 1000, function(){
                    auto_scroll_is_running = 0;
                });
            }
        }
    });
    
    initShowIn();
    $(window).on('scroll',function () {
        initShowIn();
    });
    $('.rd_ovh').on('scroll',function () {
        initShowIn();
    });
});

function initShowIn() {
    $('.rd_show_in').each(function (index,obj) {
        //如果消失了
        if(!$(this).visible(true)) {

            $(this).removeClass('rd_show_default');
            $(this).removeClass('rd_show_up');
            $(this).removeClass('rd_show_down');

            //從上面消失，下次出現要補 上到下
            if(($(window).scrollTop() - $(this).offset().top - $(this).height()) > 0){
                $(this).data('show_type','down');
            //從下面消失，下次出現要補 下到上
            } else if(($(window).scrollTop() - $(this).offset().top + $(window).height()) < 0){
                $(this).data('show_type','up');
            }

            //設定為未開啟
            $(this).data('is_show',0);
        }else{
            //未開啟才會被啟用
            if($(this).data('is_show') === 0) {
                if ($(this).data('show_type') !== undefined) {
                    $(this).addClass('rd_show_' + $(this).data('show_type'));
                    $(this).data('is_show',1);
                }
            //如果未設定
            } else if($(this).data('is_show') === undefined){
                $(this).addClass('rd_show_default');
                $(this).data('is_show',1);
            }
        }
    });
}
